import React, { useState } from 'react';
import OrderTable from '../Tables/OrderTable';
import MirrorOrderTable from '../Tables/MirrorOrderTable';
import { ChartTabs } from '../components';

const ORDER_TABS = [
  { id: 'orders', title: 'Orders' },
  { id: 'mirror', title: 'Mirror Orders' },
];

const Orders = () => {
  const [activeTab, setActiveTab] = useState('orders');

  return (
    <div className="flex flex-col gap-y-4">
      <div className="flex">
        <ChartTabs
          tabs={ORDER_TABS}
          selected={activeTab}
          onSelect={setActiveTab}
        />
      </div>
      {activeTab === 'orders' ? <OrderTable /> : <MirrorOrderTable />}
    </div>
  );
};

export default Orders;
